import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./BrandsTypeSearch.style.css";
import audi       from "../assets/brandtypes/audi-logo.svg";
import bmw        from "../assets/brandtypes/bmw-logo.svg";
import ford       from "../assets/brandtypes/ford-logo.svg";
import mercedes   from "../assets/brandtypes/mercedes-logo.svg";
import porsche    from "../assets/brandtypes/porsche-logo.svg";
import renault    from "../assets/brandtypes/renault-logo.svg";
import toyota     from "../assets/brandtypes/toyota-logo.svg";
import volkswagen from "../assets/brandtypes/volkswagen-logo.svg";

const brands = [
  { name: "Audi",       value: 5,  image: audi },
  { name: "BMW",        value: 3,  image: bmw },
  { name: "Mercedes",   value: 4,  image: mercedes },
  { name: "Volkswagen", value: 2,  image: volkswagen },
  { name: "Renault",    value: 12, image: renault },
  { name: "Porsche",    value: 27, image: porsche },
  { name: "Toyota",     value: 1,  image: toyota },
  { name: "Ford",       value: 6,  image: ford },
];

export const BrandsTypeSearch = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <section className="brs">
      <div className="brs__inner">
        <div className="brs__head">
          <span className="brs__label">{t("topBrands")}</span>
          <h2 className="brs__title">{t("searchByBrand")}</h2>
        </div>

        <div className="brs__grid">
          {brands.map((b) => (
            <div
              key={b.value}
              className="brs__card"
              onClick={() => navigate(`/featured-cars?brandId=${b.value}`)}
            >
              <img src={b.image} alt={b.name} />
              <span className="brs__card-name">{b.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
